import {Component, Input, OnInit} from '@angular/core';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {SharedModule} from "../../../../shared/shared.module";
import {SvgIconComponent} from "angular-svg-icon";
import {KeyValuePipe, NgForOf, NgIf} from "@angular/common";
import {Base64} from "../../../../shared/utils/utils.functions";
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-documents-candidat',
  templateUrl: './documents-candidat.component.html',
  styleUrl: './documents-candidat.component.scss',
  imports: [
    SharedModule,
    NgxIntlTelInputModule,
    SvgIconComponent,
    NgIf,
    NgForOf,
    KeyValuePipe
  ],
  standalone: true
})
export class CanidateDocsComponent implements OnInit {
  @Input() candidate!: any;

  public allDocs = {
    "IDENTITÉ": [
      {
        label: "Passeport",
        attr: "passport"
      },
      {
        label: "Titre de séjour (Recto)",
        attr: "sejourFace"
      },
      {
        label: "Titre de séjour (Verso)",
        attr: "sejourBack"
      },
      {
        label: "Votre pièce d'identité (Recto)",
        attr: "idFace"
      },
      {
        label: "Votre pièce d'identité (Verso)",
        attr: "idBack"
      }
    ],
    "RELEVE D'IDENTITE BANCAIRE": [
      {
        label: "Relevé d'identité bancaire",
        attr: "bankDetails"
      }
    ],
    "ASSURANCE MALADIE": [
      {
        label: "Carte vitale ou attestation de sécurité sociale",
        attr: "socialSecurityCertif"
      }
    ],
    "JUSTIFICATIF DE DOMICILE": [
      {
        label: "Pièce d'identité de la personne qui vous héberge",
        attr: "letterSignedByHost"
      },
      {
        label: "Lettre de l'hébergeant signée certifiant que vous habitez chez lui",
        attr: "justificatifDomicileHost"
      },
      {
        label: "Justificatif de domicile de moins d'un an au nom de l'hébergeant",
        attr: "justificatifDomicile"
      },
      {
        label: "Facture de téléphone",
        attr: "phoneBill"
      },
      {
        label: "Facture d'électricité ou de gaz",
        attr: "electroBill"
      },
      {
        label: "Quittance de loyer émanant d'un organisme social ou d'une agence immobilière",
        attr: "quittanceImmob"
      },
      {
        label: "Titre de propriété",
        attr: "propertyTitle"
      },
      {
        label: "Facture d'eau",
        attr: "waterBill"
      },
      {
        label: "Avis d'imposition ou certification de non imposition",
        attr: "certImpos"
      },
      {
        label: "Justificatif de taxe d'habitation ou de taxe foncière",
        attr: "taxBill"
      },
      {
        label: "Attestation ou facture d'assurance du logement",
        attr: "assuranceLogement"
      }
    ],
    "CARTE GRISE DE VOTRE VÉHICULE": [
      {
        label: "Carte grise de votre véhicule",
        attr: "carteGrise"
      }
    ],
    "ASSURANCES RESPONSABILITÉ PROFESSIONNELLE SI VOUS EN DISPOSEZ": [
      {
        label: "Assurances responsabilité professionnelle si vous en disposez",
        attr: "enrollmentCertificate"
      }
    ],
    "PROFESSION": [
      {
        label: "Votre CVs",
        attr: "cv"
      },
      {
        label: "Diplôme principal",
        attr: "firstDiplome"
      },
      {
        label: "Autre diplôme (Deuxième)",
        attr: "secondDiplome"
      },
      {
        label: "Autre diplôme (Troisième)",
        attr: "thirdDiplome"
      }
    ]
  }

  constructor(private http: HttpClient) {
  }

  ngOnInit(): void {
  }

  download(attr: any) {
    if (this.candidate[attr].includes('/api')) {
      this.downloadFile(this.candidate[attr], attr)
      return;
    }
    this.downloadBase64File(this.candidate[attr], attr)
  }

  downloadFile(_dataFile: string, _filename: string) {
    this.http.get(`${environment.api.BASE_URL}${_dataFile}`, {
      responseType: 'blob',
      observe: 'response'
    }).subscribe({
      next: async (response: any) => {
        const blob = response.body as Blob;
        let extension = await this.detectFileExtension(blob);

        // Get MIME type from Content-Type header
        const mimeType = response.headers.get('Content-Type') || blob.type || 'application/octet-stream';

        // Detect file extension based on MIME type
        // const extension = this.getExtensionFromMime(mimeType);
        const fileName = `${_filename}${extension}`;

        // Create and trigger download
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        // Cleanup — deferred so the browser actually starts the download before the
        // object URL is revoked (immediate revoke can drop the first click).
        setTimeout(() => {
          a.remove();
          window.URL.revokeObjectURL(url);
        }, 1000);
      },
      error: (err: any) => {
        console.error('File download failed:', err);
      }
    });
  }

    private getExtensionFromMime(mimeType: string): string {
    const map: Record<string, string> = {
      'application/pdf': '.pdf',
      'image/png': '.png',
      'image/jpeg': '.jpg',
      'image/jpg': '.jpg',
      'image/gif': '.gif',
      'text/plain': '.txt',
      'text/csv': '.csv',
      'application/zip': '.zip',
      'application/json': '.json',
      'application/vnd.ms-excel': '.xls',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
      'application/msword': '.doc',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
      'application/vnd.ms-powerpoint': '.ppt',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation': '.pptx'
    };

    return map[mimeType] || '';
  }

  private async detectFileExtension(blob: Blob): Promise<string | null> {
    const buffer = await blob.slice(0, 8).arrayBuffer();
    const bytes = new Uint8Array(buffer);
    const hex = Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('').toUpperCase();

    if (hex.startsWith('25504446')) return '.pdf'; // PDF
    if (hex.startsWith('89504E47')) return '.png'; // PNG
    if (hex.startsWith('FFD8FF')) return '.jpg';   // JPEG
    if (hex.startsWith('47494638')) return '.gif'; // GIF
    if (hex.startsWith('504B0304')) return '.zip'; // ZIP, DOCX, XLSX, PPTX
    if (hex.startsWith('D0CF11E0')) return '.doc'; // Old MS Office

    return null;
  }

  downloadBase64File(_dataFile: string, filename: string): void {
    let decoded = Base64.decode(_dataFile);
    let extension = undefined;
    let lowerCase = decoded.toLowerCase();
    if (lowerCase.indexOf('png') !== -1) extension = 'png';
    else if (lowerCase.indexOf('pdf') !== -1) extension = 'pdf';
    else  extension = 'jpg';
    const arrayBuffer = this.base64ToArrayBuffer(_dataFile);
    const blob = new Blob([arrayBuffer], {
      type:
        extension == 'pdf' ? 'application/pdf' : 'image/' + extension,
    });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = filename + '.' + extension;
    document.body.appendChild(link);
    link.click();
    // Deferred cleanup so the first click reliably triggers the download.
    setTimeout(() => {
      link.remove();
      URL.revokeObjectURL(url);
    }, 1000);
  }

  base64ToArrayBuffer(base64: string) {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes.buffer;
  }

  getOrderedDocs() {
    return Object.entries(this.allDocs)
      .map(([category, docs]) => {
        const filteredDocs = docs.filter(doc => !!this.candidate[doc.attr]);
        return filteredDocs.length > 0 ? {category, docs: filteredDocs} : null;
      })
      .filter(category => category !== null);
  }

}
